(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/helpers/dialog/player-forecast-error.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/helpers/dialog/player-forecast-error.js');
"use strict";

const {
  BetterDialog
} = svs.components.lbUi.betterDialog;
const getPlayerForecastError = () => new BetterDialog().setType(BetterDialog.TYPES.ERROR).setIcon('exclamation-sign').setTitle('Något gick fel').addText('Just nu kan vi inte visa fullständig information om ditt spel.').compose();
setGlobal('svs.components.tipsen.store.helpers.dialog.playerForecastError', {
  getPlayerForecastError
});

 })(window);